import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PrimaryButton, Icon, Checkbox, DLTextField } from 'appSrc/components/UI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { parseYouTubeUrl, convertYouTubeIdToImg } from 'appSrc/utils';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import style from './styles/style.module.css';

class VideoImageForm extends PureComponent {
    constructor(props) {
        super( props );

        var youtubeLink = '';
        var ytid = '';
        var isValid = false;
        var useTYThumb = true;

        if( this.props.initialValues.youtube ) {
            youtubeLink = this.props.initialValues.youtube.trim();
            ytid = parseYouTubeUrl( youtubeLink );
            isValid = ytid !== youtubeLink;
            if( isValid ) {
                youtubeLink = 'https://youtube.com/watch?v=' + ytid;
            }

            if( this.props.initialValues.selectedImage ) {
                var matchTest = new RegExp( `^https:\/\/img.youtube.com\/vi\/${ ytid }\/.*`  );
                useTYThumb = matchTest.test( this.props.initialValues.selectedImage );
            }
        } else if( this.props.initialValues.selectedImage ) {
            useTYThumb = false;
        }

        this.state = {
            selectedImage: this.props.initialValues.selectedImage || null,
            youtubeLink: youtubeLink,
            linkValid: isValid,
            youtubeId: ytid,
            useTYThumb: useTYThumb,
            videoImage: useTYThumb ? this.props.initialValues.selectedImage : null,
            quality: 'high',
        };

        this.regressionCount = 0;
    }
    updateYT = ( e, { value } ) => {
        this.regressionCount = 0;
        var url = value.trim();
        var ytid = parseYouTubeUrl( url );
        var isValid = ytid !== url;
        this.setState( { youtubeLink: url, youtubeId: ytid, linkValid: isValid } );
        if( isValid && this.state.useTYThumb ) {
            this.setState( { videoImage: convertYouTubeIdToImg( ytid, 'jpg' ), quality: 'high' } );
        } else {
            this.setState( { videoImage: null, quality: 'high' } );
        }
    }
    updateUseThumb = ( e, value ) => {
        this.setState( { useTYThumb: value, selectedImage: null } );
        if( value && this.state.linkValid ) {
            this.setState( { videoImage: convertYouTubeIdToImg( this.state.youtubeId, 'jpg' ), quality: 'high' } );
        } else {
            this.setState( { videoImage: null } );
        }
    }
    cropFinish = ( image ) => {
        this.setState( { selectedImage: image, useTYThumb: false } );
    }
    checkCoverImage = ( e ) => {
        if( ( this.regressionCount < 2 ) && e.target.naturalHeight <= 90 ) {
            ++this.regressionCount;
            switch ( this.regressionCount ) {
                case 1:
                    this.setState( {
                        videoImage: convertYouTubeIdToImg( this.state.youtubeId, 'med/jpg' ),
                        quality: 'medium',
                    } );
                    break;
                case 2:
                    this.setState( {
                        videoImage: convertYouTubeIdToImg( this.state.youtubeId, 'small/jpg' ),
                        quality: 'low',
                    } );
                    break;
                default:
                    this.regressionCount = 3;
                    break;
            }
        } else {
            if( this.state.useTYThumb ) {
                this.setState( { selectedImage: this.state.videoImage } );
            }
        }
    }
    handleSubmit = () => {
        this.props.onSubmit( {
            selectedImage: this.state.selectedImage,
            youtubeLink: this.state.youtubeLink,
            linkValid: this.state.linkValid,
            useTYThumb: this.state.useTYThumb,
            videoImage: this.state.videoImage,
            quality: this.state.quality,
            youtubeId: this.state.youtubeId,
        } );
    }
    render() {
        const { selectedImage, youtubeLink, useTYThumb, linkValid, videoImage } = this.state;

        const isValid = !!selectedImage;
        const { yT } = this.props;

        var iconColor = '#DDDDDD';
        var error = false;
        if( youtubeLink ) {
            iconColor = '#FFA500';
            error = 'Invalid YouTube URL';
            if( linkValid ){
                iconColor = '#FF0000';
                error = false;
            }
        }

        var thumbError = false;
        if( selectedImage == videoImage && this.state.quality !== 'high' ) {
            thumbError = ( 'Warning: This video does not have a high-quality thumbnail image. \nYou may: \n- Use this thumbnail anyway. \n- Refresh the thumbnail on YouTube and then double-click the above checkbox to retry. \n- Upload your own image using the button above.' );
        }

        var fetching = videoImage && useTYThumb && ( selectedImage !== videoImage );

        return (
            <div className={ style.selectorForm }>
                <div className={ style.imageDisplay }>
                    { fetching ?
                        <LoadingReplace />
                        :
                        <img src={ selectedImage } />
                    }
                </div>
                <div className={ style.videoImageForm }>
                    <div className={ style.addMediaDiv }>
                        <ImageCropModalWrapper
                        aspectRatio={ 16/9 }
                        wrapperStyle={ { display: 'block' } }
                        onFinish={ this.cropFinish }>
                            <PrimaryButton
                            label={ (<span style={ { display: 'flex', alignItems: 'center' } }>
                                <Icon size={ 30 } icon='upload' />&nbsp;Upload Photo
                            </span>) }
                            value="image"
                            fullWidth
                            reverse />
                        </ImageCropModalWrapper>

                        { yT &&
                            <div>
                                <p className={ style.or }>or</p>
                                <div className={ style.slug }>
                                    <DLTextField
                                    id='youtube'
                                    name='youtube'
                                    icon={ <i className='icon'><FontAwesomeIcon icon={ faYoutube }
                                    style={ { color: iconColor, verticalAlign: 'top' } }
                                    size='lg' /></i> }
                                    iconPosition='left'
                                    placeholder='Insert YouTube link'
                                    value={ youtubeLink }
                                    onChange={ this.updateYT }
                                    fullWidth
                                    error={ error }
                                    noError={ !error } />

                                    <Checkbox label='Use YouTube Thumbnail?'
                                    checked={ useTYThumb }
                                    onChange={ this.updateUseThumb }
                                    disabled={ youtubeLink == '' || !linkValid }
                                    style={ { paddingLeft: '8px', marginTop: '5px' } } />

                                    { thumbError &&
                                        <div className={ style.errorBlock }>{ thumbError }</div>
                                    }
                                </div>
                                <div className={ style.imageCheck }>
                                    <div>
                                        { videoImage &&
                                        <img className={ style.primaryImage }
                                        onLoad={ this.checkCoverImage }
                                        src={ videoImage }
                                        alt="cover image" />
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className={ style.submitButton } style={ { marginTop: '15px' } }>
                        <PrimaryButton
                        label="Next"
                        type="button"
                        onClick={ this.handleSubmit }
                        fullWidth
                        disabled={ !isValid } />
                    </div>
                </div>
            </div>
        );
    }
}
VideoImageForm.defaultProps = {
    initialValues: {},
    yT: true,
};


const mapStateToProps = ( state ) => {
    return {
        user: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( VideoImageForm );
